<template>
  <div class="section3">
    <div class="title">未来就绪的概念</div>
    <div class="logos">
      <div class="logo">
        <img class="logo-normal" src="./logo/section31.png" />
        <div class="logo-title">
          通讯
        </div>
        <div class="logo-subtitle">
          除了日常消息传递，通友允许人类与智能器械进行沟通。
        </div>
      </div>
      <div class="logo">
        <img class="logo-normal" src="./logo/section32.png" />
        <div class="logo-title">
          翻译
        </div>
        <div class="logo-subtitle">
          实时翻译超过11种语言。使用最好的工具走遍世界。
        </div>
      </div>
      <div class="logo">
        <img class="logo-normal" src="./logo/section33.png" />
        <div class="logo-title">
          商圈
        </div>
        <div class="logo-subtitle">
          专为真正的商业用户而打造。为企业对企业纯粹地创造价值，具备无尽的潜力。
        </div>
      </div>
      <div class="logo">
        <img class="logo-normal" src="./logo/section34.png" />
        <div class="logo-title">
          家居
        </div>
        <div class="logo-subtitle">
          一个应用程序控制所有智能设备。生活变得轻鬆。更多时间放鬆，更多时间享受。
        </div>
      </div>
      <div class="logo">
        <img class="logo-normal" src="./logo/section35.png" />
        <div class="logo-title">
          商店
        </div>
        <div class="logo-subtitle">
          F2C（工厂直到消费者）购物。为您提供绝对最直接的在线购物体验
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Footer from "../Footer";

export default {
  components: {
    Footer
  }
};
</script>

<style lang="scss" scoped>
.section3 {
  height: 100%;
  background: #F0F2F3;
  .title {
    font-size: 0.18rem;
    padding-top: 0.5rem;
    text-align: center;
    color: #333;
  }
  .logos {
    width: 7.52rem;
    margin: 0.5rem auto;
    height: 4rem;
  }
  .logo {
    position: relative;
    display: inline-block;
    vertical-align: middle;
    width: 2.3rem;
    height: 1.4rem;
    margin-right: 0.2rem;
    margin-bottom: 0.2rem;
    transition: all 0.3s;
    &:nth-child(3n + 3) {
      margin-right: 0;
    }
    .logo-normal {
      position: absolute;
      top: 0;
      left: 0.85rem;
      opacity: 1;
      transition: all 0.3s;
    }
    .logo-title {
      font-size: 0.15rem;
      color: #333;
      position: absolute;
      top: 0.65rem;
      text-align: center;
      width: 100%;
    }
    .logo-subtitle {
      font-size: 0.12rem;
      color: #333;
      position: absolute;
      top: 0.9rem;
      width: 80%;
      left: 10%;
      text-align: center;
    }
  }
}
</style>
